import fetch from '../utils/fetch'

export function ownerlist(params) {
  return fetch({
    method:'GET',
    url:'/owner/list',
    params
  })
}


export function ownersave(params) {
  return fetch({
    method:'POST',
    url:'/owner/save',
    data:params
  })
}

//
// export function ownerupdate(params) {
//   return fetch({
//     method:'POST',
//     url:'/owner/update',
//     data:params
//   })
// }

export function ownerdelete(params) {
  return fetch({
    method:'POST',
    url:'/owner/delete',
    params
  })
}

export function getOwnerOtherInfo(params) {
  return fetch({
    method:'GET',
    url:'/owner/getOwnerOtherInfo',
    params

  })
}

export function getOwnerInfo(params) {
  return fetch({
    method:'GET',
    url:'/owner/getOwnerInfo',
    params

  })
}

export function toUpdateOwner(params) {
  return fetch({
    method:'POST',
    url:'/owner/toUpdateOwner',
    params
  })
}

export function ownerupdate(params) {
  return fetch({
    method:'POST',
    url:'/owner/update',
    data:params
  })
}
